import { createTranslations } from '@npco/common-utils-translations'

export const searchStringLengthRequirementInfoTranslations = createTranslations(
  {
    info: 'Please enter a minimum of 4 characters to begin searching for billers.',
  }
)
